import React from "react";

export default function MenuHarianScreen() {
  const today = new Date();
  const dayName = new Intl.DateTimeFormat("id-ID", { weekday: "long" }).format(today); // Day name in Indonesian
  const dateString = today.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }); // Full date in Indonesian

  return (
    <div className="flex p-10">
      <div className="flex flex-row gap-4 w-full">
        <div className="flex flex-col w-1/4">
          <div className="font-semibold pb-5">Menu Hari Ini</div>
          <div className="text-3xl text-[#A1232D]">{dayName}</div> {/* Display the day */}
          <div className="py-2">{dateString}</div> {/* Display the date */}
          <div className="border-t border-gray-400 w-full flex-1 pb-5"></div>
          <div className="uppercase">Karbohidrat</div> 
          <div className="font-medium pb-2">Nasi</div>
          <div className="uppercase">Sayuran</div> 
          <div className="font-medium pb-2">Sayur Tahu</div>
          <div className="uppercase">Protein</div> 
          <div className="font-medium pb-2">Daging Sapi</div>
          <div className="uppercase">Buah</div> 
          <div className="font-medium pb-2">Semangka</div>
          <div className="uppercase">Minuman</div> 
          <div className="font-medium pb-2">Susus</div>
        </div>
        <div className="flex flex-col w-1/2">
          <div className="font-semibold pb-5">Tip Masak Hari Ini</div>
          <div className="text-3xl text-[#A1232D]">{dayName}</div> {/* Display the day */}
          <div className="py-2">{dateString}</div> {/* Display the date */}
          <div className="border-t border-gray-400 w-full flex-1 pb-5"></div>
          <div className="flex flex-row h-full">
            <div className="flex flex-col w-1/2">
          <div className="font-medium">Bahan-Bahan:</div> 
          <div className="">Nasi</div>
          </div>
            <div className="flex flex-col w-1/2">
          <div className="font-medium">Cara Memasak</div> 
          <div className="">Nasi</div>
          </div>
          </div>
        </div>
        <div className="flex flex-col w-1/2">
          <div className="font-semibold pb-5 text-transparent">Tip Masak Hari Ini</div>
          <div className="text-3xl text-[#A1232D]">{dayName}</div> {/* Display the day */}
          <div className="py-2">{dateString}</div> {/* Display the date */}
          <div className="border-t border-gray-400 w-full flex-1 pb-5"></div>
          <div className="flex flex-row h-full">
            <div className="flex flex-col w-1/2">
          <div className="font-medium">Bahan-Bahan:</div> 
          <div className="">Nasi</div>
          </div>
            <div className="flex flex-col w-1/2">
          <div className="font-medium">Cara Memasak</div> 
          <div className="">Nasi</div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
